const removeObject = (sParent, id) => {
    const sParentToUse = sParent;

    if (!sParentToUse || !sParentToUse.userData.childMap) {
        return;
    }
    const sChild = sParentToUse.userData.childMap[id];

    delete sParentToUse.userData.childMap[id];
    sParent.remove(sChild);
};

const addObject = (sParent, id, sChild) => {
    const sChildToModify = sChild;
    const sParentToModify = sParent;

    sChildToModify.name = id;
    if (
        sParentToModify.userData.childMap &&
        sParentToModify.userData.childMap[id]
    ) {
        removeObject(sParent, id);
    }
    sParentToModify.add(sChildToModify);
    let childMap = sParentToModify.userData.childMap;

    if (!childMap) {
        childMap = {};
        sParentToModify.userData.childMap = childMap;
    }
    childMap[id] = sChildToModify;
};

const getObject = (sParent, id) => {
    if (!sParent) {
        return undefined;
    }
    if (!sParent.userData) {
        return undefined;
    }
    if (!sParent.userData.childMap) {
        return undefined;
    }
    const child = sParent.userData.childMap[id];

    return child;
};

export default {
    removeObject,
    addObject,
    getObject,
};
